import {ApolloLink} from 'apollo-link'
import Vue from 'vue'
import { HttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
import ApolloClient from 'apollo-client'
// import config from './env.js'

const config = {
  // prod
  // graphqlUrl: 'https://crm.restbrunch.ru:5443/graphql'

  // dev
  graphqlUrl: 'https://dev-crm.restbrunch.ru:5000/graphql'

  // old dev
  // graphqlUrl: 'http://test-brunch.restbrunch.ru:5002/graphql'
}

// try {
// } catch (err) {
//   const config = null
// }

// console.log(config)

const middlewareLink = new ApolloLink((operation, forward) => {
  if (Vue.prototype.$userControl.jwt !== null) {
    operation.setContext({
      headers: { authorization: `Bearer ${Vue.prototype.$userControl.jwt}` }
    })
  }
  return forward(operation)
})

const isProd = process.env.NODE_ENV === 'production'
const isTesting = process.env.MANUAL_TESTING === 'true'

const urlGraphql = ((!isTesting && isProd) ? `https://crm.restbrunch.ru:5443/graphql` : config.graphqlUrl)

const httpLink = new HttpLink({
  uri: urlGraphql
})

const apolloClient = new ApolloClient({
  link: middlewareLink.concat(httpLink),
  cache: new InMemoryCache(),
  connectToDevTools: true
})

export default apolloClient



// WEBPACK FOOTER //
// ./src/apolloClient.js